export default "__VITE_ASSET__ComRTRw1__"